var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarSlash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.075 32.5352C41.2875 33.3227 40.8375 34.8977 41.085 35.9777L42.6375 42.7727C43.29 45.5852 42.885 47.7002 41.49 48.7127C40.9275 49.1177 40.2525 49.3202 39.465 49.3202C38.3175 49.3202 36.9675 48.8927 35.4825 48.0152L28.89 44.1002C27.855 43.4927 26.145 43.4927 25.11 44.1002L18.5175 48.0152C16.02 49.4777 13.8825 49.7252 12.51 48.7127C12.42 48.6452 12.33 48.5777 12.2625 48.4877L40.6575 20.0927C41.6925 19.0577 43.155 18.5852 44.595 18.8327L44.9325 18.9002C47.3175 19.3052 48.915 20.3852 49.4325 21.9602C49.9275 23.5352 49.2525 25.3577 47.5425 27.0677L42.075 32.5352Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.915 36C13.1625 34.92 12.7125 33.3225 11.925 32.535L6.45749 27.0675C4.74749 25.3575 4.07249 23.535 4.56749 21.96C5.08499 20.385 6.68249 19.305 9.06749 18.9L16.0875 17.73C17.1 17.55 18.3375 16.65 18.81 15.7275L22.68 7.965C23.805 5.7375 25.335 4.5 27 4.5C28.665 4.5 30.195 5.7375 31.32 7.965L35.19 15.7275C35.4825 16.3125 36.09 16.875 36.7425 17.2575L11.4075 42.5925L12.915 36Z",
    fill: "#1F1F1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9825 5.01748C48.3075 4.34248 47.205 4.34248 46.53 5.01748L5.01748 46.5525C4.34248 47.2275 4.34248 48.33 5.01748 49.005C5.35498 49.32 5.78248 49.5 6.23248 49.5C6.68248 49.5 7.10998 49.32 7.44748 48.9825L48.9825 7.44748C49.68 6.77248 49.68 5.69248 48.9825 5.01748Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSlash);
export default __webpack_public_path__ + "static/media/star-slash.7ce577896bc4e6f3019f44194e4fb9d2.svg";
export { ForwardRef as ReactComponent };